import React, { useState } from "react";
import { toast } from "react-toastify";
import { useAxiosInstance } from "../../../services/Interceptor";
import { updatePassword } from "../../../services/AdminService";
import { useDispatch, useSelector } from "react-redux";
import {
  resetUserState,
  updatePasswordFail,
  updatePasswordRequest,
  updatePasswordSuccess,
} from "../../../store/slices/userSlice";

export default function UpdatePassword({ title }) {
  const apiInstance = useAxiosInstance();
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [repeatPassword, setRepeatPassword] = useState("");
  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.user);

  const handleUpdatePassword = async (e) => {
    e.preventDefault();

    if (!currentPassword || !newPassword || !repeatPassword) {
      toast.error("All fields are required.");
      return;
    }
    if (newPassword.length < 8) {
      toast.error("The new password must be at least 8 characters long.");
      return;
    }
    const alphanumericRegex = /^(?=.*[a-zA-Z])(?=.*\d)[a-zA-Z\d]+$/;
    if (!alphanumericRegex.test(newPassword)) {
      toast.error("The new password must be alphanumeric.");
      return;
    }
    if (newPassword !== repeatPassword) {
      toast.error("The passwords do not match.");
      return;
    }

    if (currentPassword === newPassword) {
      toast.error(
        "The new password must be different from the current password.",
      );
      return;
    }

    dispatch(updatePasswordRequest());

    try {
      await updatePassword(
        apiInstance,
        currentPassword,
        newPassword,
        repeatPassword,
      );
      dispatch(updatePasswordSuccess());
      toast.success("Password updated successfully!", { autoClose: 5000 });
      setCurrentPassword("");
      setNewPassword("");
      setRepeatPassword("");
      dispatch(resetUserState());
    } catch (err) {
      const errorMessage = err.message || "An error occurred";
      toast.error(errorMessage, { autoClose: 5000 });
      dispatch(updatePasswordFail(errorMessage));
    }
  };

  return (
    <div className="bg-white shadow-lg mt-4 py-6 rounded-lg border-gray-300">
      <div className="w-full px-4">
        <h1 className="text-xl  uppercase">{title}</h1>
        <form
          className="mt-4 space-y-4 lg:mt-5 md:space-y-5"
          onSubmit={handleUpdatePassword}
        >
          <div className="grid grid-cols-2 gap-2">
            <div className="w-full px-3">
              <div className="">
                <label className="font-medium text-gray-900">
                  Current Password
                </label>
                <input
                  type="password"
                  name="currentPassword"
                  value={currentPassword}
                  onChange={(e) => setCurrentPassword(e.target.value)}
                  placeholder="**********"
                  className="block w-full mt-2 rounded-md border-0 py-3 pl-4 pr-20 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-600 bg-slate-200"
                />
              </div>
            </div>
            <div className="w-full px-3">
              <div className="">
                <label className="font-medium text-gray-900">
                  New Password
                </label>
                <input
                  type="password"
                  name="newPassword"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  placeholder="**********"
                  className="block w-full mt-2 rounded-md border-0 py-3 pl-4 pr-20 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-600 bg-slate-200"
                />
              </div>
            </div>
            <div className="w-full px-3">
              <div className="mt-4">
                <label className="font-medium text-gray-900">
                  Confirm New Password
                </label>
                <input
                  type="password"
                  name="repeatPassword"
                  value={repeatPassword}
                  onChange={(e) => setRepeatPassword(e.target.value)}
                  placeholder="**********"
                  className="block w-full mt-2 rounded-md border-0 py-3 pl-4 pr-20 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-600 bg-slate-200"
                />
              </div>
            </div>
            <div className="w-full px-3">
              <div className="mt-10 flex justify-end">
                <button
                  type="submit"
                  className={`bg-red-500 text-white px-4 py-2 rounded-md uppercase hover:bg-red-700 mt-4 ml-3  ${loading ? "opacity-50 cursor-not-allowed" : ""}`}
                  disabled={loading}
                >
                  {loading ? "Updating..." : "Update"}
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}
